import {SET_ORDERS} from "app/actions/orders";

export default function orders({action, state = []}) {
  switch(action.type) {
    case SET_ORDERS: {
      const data = action.payload;

      return data ? [...data] : [];
    }
    default:
      return state;
  }
}
